import { BadUser } from "../model/BadUser";

import * as firestoreClient from '../script/firestore-client'

const table = 'bad_user'

export function save(badUser: BadUser) {
  firestoreClient.saveWithAssignId(table, badUser)
}